import { supabase } from './supabaseClient';

export const fetchAndBuildHierarchy = async (department) => {
    // department: 'management' or 'academics'
    try {
        const { data, error } = await supabase
            .from('staff')
            .select('*')
            .eq('department', department.toLowerCase())
            .order('created_at', { ascending: true });
        
        if (error) throw error;
        if (!data || data.length === 0) return null;
        
        return buildTree(data);
    } catch (err) {
        console.error("Failed to fetch hierarchy", err);
        return null;
    }
}

const buildTree = (flatList) => {
    const map = {};
    const roots = [];
    
    // First pass: create map of all nodes
    flatList.forEach(node => {
        map[node.id] = { ...node, children: [] };
    });
    
    // Second pass: link children to parents
    flatList.forEach(node => {
        if (node.parent_id && map[node.parent_id]) {
            map[node.parent_id].children.push(map[node.id]);
        } else {
            // No parent or invalid parent -> it's a root
            roots.push(map[node.id]);
        }
    });
    
    // Return the first root (usually the top leader)
    return roots.length > 0 ? roots[0] : null;
}
